import { useState, useRef, useEffect } from "react";
import "../dashboardOverview.css";
import toast from "react-hot-toast";
import { useAppServices } from "hook/services";

const CURRENCIES = [
  // Major / Most Used
  { code: "USD", symbol: "$", label: "US Dollar" },
  { code: "EUR", symbol: "€", label: "Euro" },
  { code: "GBP", symbol: "£", label: "British Pound" },
  { code: "JPY", symbol: "¥", label: "Japanese Yen" },
  { code: "CNY", symbol: "¥", label: "Chinese Yuan" },
  { code: "CHF", symbol: "Fr", label: "Swiss Franc" },
  { code: "CAD", symbol: "CA$", label: "Canadian Dollar" },
  { code: "AUD", symbol: "A$", label: "Australian Dollar" },
  { code: "NZD", symbol: "NZ$", label: "New Zealand Dollar" },
  { code: "HKD", symbol: "HK$", label: "Hong Kong Dollar" },
  { code: "SGD", symbol: "S$", label: "Singapore Dollar" },

  // Asia
  { code: "INR", symbol: "₹", label: "Indian Rupee" },
  { code: "PKR", symbol: "₨", label: "Pakistani Rupee" },
  { code: "BDT", symbol: "৳", label: "Bangladeshi Taka" },
  { code: "LKR", symbol: "රු", label: "Sri Lankan Rupee" },
  { code: "NPR", symbol: "रू", label: "Nepalese Rupee" },
  { code: "MVR", symbol: "Rf", label: "Maldivian Rufiyaa" },
  { code: "BTN", symbol: "Nu", label: "Bhutanese Ngultrum" },
  { code: "MMK", symbol: "K", label: "Myanmar Kyat" },
  { code: "THB", symbol: "฿", label: "Thai Baht" },
  { code: "VND", symbol: "₫", label: "Vietnamese Dong" },
  { code: "KHR", symbol: "៛", label: "Cambodian Riel" },
  { code: "LAK", symbol: "₭", label: "Lao Kip" },
  { code: "MYR", symbol: "RM", label: "Malaysian Ringgit" },
  { code: "IDR", symbol: "Rp", label: "Indonesian Rupiah" },
  { code: "PHP", symbol: "₱", label: "Philippine Peso" },
  { code: "BND", symbol: "B$", label: "Brunei Dollar" },
  { code: "TWD", symbol: "NT$", label: "Taiwan Dollar" },
  { code: "KRW", symbol: "₩", label: "South Korean Won" },
  { code: "KPW", symbol: "₩", label: "North Korean Won" },
  { code: "MNT", symbol: "₮", label: "Mongolian Tugrik" },
  { code: "KZT", symbol: "₸", label: "Kazakhstani Tenge" },
  { code: "UZS", symbol: "so'm", label: "Uzbekistani Som" },
  { code: "TJS", symbol: "SM", label: "Tajikistani Somoni" },
  { code: "KGS", symbol: "с", label: "Kyrgyzstani Som" },
  { code: "TMT", symbol: "T", label: "Turkmenistani Manat" },
  { code: "AFN", symbol: "؋", label: "Afghan Afghani" },

  // Middle East
  { code: "AED", symbol: "د.إ", label: "UAE Dirham" },
  { code: "SAR", symbol: "﷼", label: "Saudi Riyal" },
  { code: "QAR", symbol: "﷼", label: "Qatari Riyal" },
  { code: "KWD", symbol: "د.ك", label: "Kuwaiti Dinar" },
  { code: "BHD", symbol: ".د.ب", label: "Bahraini Dinar" },
  { code: "OMR", symbol: "﷼", label: "Omani Rial" },
  { code: "JOD", symbol: "د.ا", label: "Jordanian Dinar" },
  { code: "IQD", symbol: "ع.د", label: "Iraqi Dinar" },
  { code: "IRR", symbol: "﷼", label: "Iranian Rial" },
  { code: "SYP", symbol: "£", label: "Syrian Pound" },
  { code: "LBP", symbol: "ل.ل", label: "Lebanese Pound" },
  { code: "ILS", symbol: "₪", label: "Israeli Shekel" },
  { code: "YER", symbol: "﷼", label: "Yemeni Rial" },

  // Europe (Non-Euro)
  { code: "SEK", symbol: "kr", label: "Swedish Krona" },
  { code: "DKK", symbol: "kr", label: "Danish Krone" },
  { code: "ISK", symbol: "kr", label: "Icelandic Króna" },
  { code: "CZK", symbol: "Kč", label: "Czech Koruna" },
  { code: "HUF", symbol: "Ft", label: "Hungarian Forint" },
  { code: "PLN", symbol: "zł", label: "Polish Zloty" },
  { code: "RON", symbol: "lei", label: "Romanian Leu" },
  { code: "BGN", symbol: "лв", label: "Bulgarian Lev" },
  { code: "HRK", symbol: "kn", label: "Croatian Kuna" },
  { code: "RSD", symbol: "din", label: "Serbian Dinar" },
  { code: "BAM", symbol: "KM", label: "Bosnia-Herzegovina Mark" },
  { code: "MKD", symbol: "ден", label: "Macedonian Denar" },
  { code: "ALL", symbol: "L", label: "Albanian Lek" },
  { code: "MDL", symbol: "L", label: "Moldovan Leu" },
  { code: "UAH", symbol: "₴", label: "Ukrainian Hryvnia" },
  { code: "RUB", symbol: "₽", label: "Russian Ruble" },
  { code: "BYN", symbol: "Br", label: "Belarusian Ruble" },
  { code: "GEL", symbol: "₾", label: "Georgian Lari" },
  { code: "AMD", symbol: "֏", label: "Armenian Dram" },
  { code: "AZN", symbol: "₼", label: "Azerbaijani Manat" },
  { code: "TRY", symbol: "₺", label: "Turkish Lira" },
  { code: "NOK", symbol: "kr", label: "Norwegian Krone" },
  { code: "GIP", symbol: "£", label: "Gibraltar Pound" },
  { code: "FKP", symbol: "£", label: "Falkland Islands Pound" },
  { code: "SHP", symbol: "£", label: "Saint Helena Pound" },

  // Africa
  { code: "NGN", symbol: "₦", label: "Nigerian Naira" },
  { code: "ZAR", symbol: "R", label: "South African Rand" },
  { code: "KES", symbol: "KSh", label: "Kenyan Shilling" },
  { code: "UGX", symbol: "USh", label: "Ugandan Shilling" },
  { code: "TZS", symbol: "TSh", label: "Tanzanian Shilling" },
  { code: "ETB", symbol: "Br", label: "Ethiopian Birr" },
  { code: "GHS", symbol: "₵", label: "Ghanaian Cedi" },
  { code: "EGP", symbol: "£", label: "Egyptian Pound" },
  { code: "MAD", symbol: "د.م.", label: "Moroccan Dirham" },
  { code: "TND", symbol: "د.ت", label: "Tunisian Dinar" },
  { code: "DZD", symbol: "د.ج", label: "Algerian Dinar" },
  { code: "LYD", symbol: "ل.د", label: "Libyan Dinar" },
  { code: "SDG", symbol: "ج.س.", label: "Sudanese Pound" },
  { code: "AOA", symbol: "Kz", label: "Angolan Kwanza" },
  { code: "XAF", symbol: "Fr", label: "Central African CFA Franc" },
  { code: "XOF", symbol: "Fr", label: "West African CFA Franc" },
  { code: "MZN", symbol: "MT", label: "Mozambican Metical" },
  { code: "ZMW", symbol: "ZK", label: "Zambian Kwacha" },
  { code: "BWP", symbol: "P", label: "Botswanan Pula" },
  { code: "NAD", symbol: "N$", label: "Namibian Dollar" },
  { code: "ZWL", symbol: "Z$", label: "Zimbabwean Dollar" },
  { code: "MWK", symbol: "MK", label: "Malawian Kwacha" },
  { code: "RWF", symbol: "Fr", label: "Rwandan Franc" },
  { code: "BIF", symbol: "Fr", label: "Burundian Franc" },
  { code: "DJF", symbol: "Fr", label: "Djiboutian Franc" },
  { code: "ERN", symbol: "Nfk", label: "Eritrean Nakfa" },
  { code: "SOS", symbol: "Sh", label: "Somali Shilling" },
  { code: "MGA", symbol: "Ar", label: "Malagasy Ariary" },
  { code: "MUR", symbol: "₨", label: "Mauritian Rupee" },
  { code: "SCR", symbol: "₨", label: "Seychellois Rupee" },
  { code: "CVE", symbol: "$", label: "Cape Verdean Escudo" },
  { code: "STN", symbol: "Db", label: "São Tomé Príncipe Dobra" },
  { code: "GMD", symbol: "D", label: "Gambian Dalasi" },
  { code: "GNF", symbol: "Fr", label: "Guinean Franc" },
  { code: "SLL", symbol: "Le", label: "Sierra Leonean Leone" },
  { code: "LRD", symbol: "$", label: "Liberian Dollar" },
  { code: "SZL", symbol: "L", label: "Swazi Lilangeni" },
  { code: "LSL", symbol: "L", label: "Lesotho Loti" },
  { code: "KMF", symbol: "Fr", label: "Comorian Franc" },
  { code: "MRU", symbol: "UM", label: "Mauritanian Ouguiya" },
  { code: "CDF", symbol: "Fr", label: "Congolese Franc" },
  { code: "HTG", symbol: "G", label: "Haitian Gourde" },

  // Americas
  { code: "BRL", symbol: "R$", label: "Brazilian Real" },
  { code: "MXN", symbol: "MX$", label: "Mexican Peso" },
  { code: "ARS", symbol: "$", label: "Argentine Peso" },
  { code: "CLP", symbol: "$", label: "Chilean Peso" },
  { code: "COP", symbol: "$", label: "Colombian Peso" },
  { code: "PEN", symbol: "S/.", label: "Peruvian Sol" },
  { code: "VES", symbol: "Bs.S", label: "Venezuelan Bolívar" },
  { code: "UYU", symbol: "$U", label: "Uruguayan Peso" },
  { code: "PYG", symbol: "₲", label: "Paraguayan Guaraní" },
  { code: "BOB", symbol: "Bs.", label: "Bolivian Boliviano" },
  { code: "ECU", symbol: "$", label: "Ecuadorian (uses USD)" },
  { code: "GYD", symbol: "$", label: "Guyanese Dollar" },
  { code: "SRD", symbol: "$", label: "Surinamese Dollar" },
  { code: "TTD", symbol: "TT$", label: "Trinidad & Tobago Dollar" },
  { code: "JMD", symbol: "J$", label: "Jamaican Dollar" },
  { code: "BBD", symbol: "Bds$", label: "Barbadian Dollar" },
  { code: "BSD", symbol: "$", label: "Bahamian Dollar" },
  { code: "BZD", symbol: "BZ$", label: "Belize Dollar" },
  { code: "GTQ", symbol: "Q", label: "Guatemalan Quetzal" },
  { code: "HNL", symbol: "L", label: "Honduran Lempira" },
  { code: "NIO", symbol: "C$", label: "Nicaraguan Córdoba" },
  { code: "CRC", symbol: "₡", label: "Costa Rican Colón" },
  { code: "PAB", symbol: "B/.", label: "Panamanian Balboa" },
  { code: "DOP", symbol: "RD$", label: "Dominican Peso" },
  { code: "CUP", symbol: "$", label: "Cuban Peso" },
  { code: "AWG", symbol: "ƒ", label: "Aruban Florin" },
  { code: "ANG", symbol: "ƒ", label: "Netherlands Antillean Guilder" },
  { code: "XCD", symbol: "EC$", label: "East Caribbean Dollar" },
  { code: "KYD", symbol: "$", label: "Cayman Islands Dollar" },
  { code: "BMD", symbol: "$", label: "Bermudian Dollar" },

  // Oceania
  { code: "FJD", symbol: "FJ$", label: "Fijian Dollar" },
  { code: "PGK", symbol: "K", label: "Papua New Guinean Kina" },
  { code: "SBD", symbol: "$", label: "Solomon Islands Dollar" },
  { code: "VUV", symbol: "Vt", label: "Vanuatu Vatu" },
  { code: "WST", symbol: "T", label: "Samoan Tala" },
  { code: "TOP", symbol: "T$", label: "Tongan Paʻanga" },
  { code: "TVD", symbol: "$", label: "Tuvaluan Dollar" },
  { code: "KID", symbol: "$", label: "Kiribati Dollar" },
  { code: "XPF", symbol: "Fr", label: "CFP Franc (French Polynesia)" },
];

function CurrencySelector({ currency, onChange, agency, Update }) {
  const [open, setOpen] = useState(false);
  const AppService = useAppServices();
  const [search, setSearch] = useState("");
  const ref = useRef(null);

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
        setSearch("");
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  const filtered = CURRENCIES.filter(
    (c) =>
      c.code.toLowerCase().includes(search.toLowerCase()) ||
      c.label.toLowerCase().includes(search.toLowerCase())
  );

  const handleSelect = async (c) => {
    onChange(c);
    const payload = {
      _id: agency._id,
      currency: {
        code: c.code,
        symbol: c.symbol,
      },
    };
    const { response } = await AppService.agency.update({
      payload,
    });
    if (response?.success) {
      Update(response?.data);
      toast.success(`Change currency in to ${c.code} successfully!`);
      setOpen(false);
      setSearch("");
    } else {
      toast.error("Error while saved currency! Please try again.");
      setOpen(false);
      setSearch("");
    }
  };

  return (
    <div className="currency-selector" ref={ref}>
      <button className="currency-selector__trigger" onClick={() => setOpen((o) => !o)}>
        <span className="currency-selector__symbol">{currency.symbol}</span>
        <span className="currency-selector__code">{currency.code}</span>
        <svg
          className={`currency-selector__chevron ${open ? "is-open" : ""}`}
          width="12"
          height="12"
          viewBox="0 0 12 12"
        >
          <path
            d="M2 4l4 4 4-4"
            stroke="currentColor"
            strokeWidth="1.5"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      {open && (
        <div className="currency-selector__dropdown">
          <div className="currency-selector__search-wrap">
            <input
              className="currency-selector__search"
              placeholder="Search currency…"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              autoFocus
            />
          </div>
          <ul className="currency-selector__list">
            {filtered.map((c) => (
              <li
                key={c.code}
                className={`currency-selector__item ${c.code === currency.code ? "is-active" : ""}`}
                onClick={() => handleSelect(c)}
              >
                <span className="currency-selector__item-symbol">{c.symbol}</span>
                <span className="currency-selector__item-code">{c.code}</span>
                <span className="currency-selector__item-label">{c.label}</span>
              </li>
            ))}
            {filtered.length === 0 && <li className="currency-selector__empty">No results</li>}
          </ul>
        </div>
      )}
    </div>
  );
}

export default CurrencySelector;
export { CURRENCIES };
